import { render, staticRenderFns } from "./AdminSteps.vue?vue&type=template&id=359645d3&"
import script from "./AdminSteps.vue?vue&type=script&lang=js&"
export * from "./AdminSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports